const phoneDials = [
  {
    name: 'Česká republika',
    dial_code: '+420',
    planet_part: 'Evropa'
  },
  {
    name: 'Slovensko',
    dial_code: '+421',
    planet_part: 'Evropa'
  },
  {
    name: 'Afghánistán',
    dial_code: '+93',
    planet_part: 'Asie'
  },
  {
    name: 'Albánie',
    dial_code: '+355',
    planet_part: 'Evropa'
  },
  {
    name: 'Alžírsko',
    dial_code: '+213',
    planet_part: 'Afrika'
  },
  {
    name: 'Americká Samoa',
    dial_code: '+1684',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Americké Panenské ostrovy',
    dial_code: '+134',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Andorra',
    dial_code: '+376',
    planet_part: 'Evropa'
  },
  {
    name: 'Angola',
    dial_code: '+244',
    planet_part: 'Afrika'
  },
  {
    name: 'Anguilla',
    dial_code: '+1264',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Antigua a Barbuda',
    dial_code: '+1268',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Argentina',
    dial_code: '+54',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Arménie',
    dial_code: '+374',
    planet_part: 'Asie'
  },
  {
    name: 'Aruba',
    dial_code: '+297',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Ascension',
    dial_code: '+247',
    planet_part: 'Afrika'
  },
  {
    name: 'Austrálie',
    dial_code: '+61',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Australská teritoria',
    dial_code: '+672',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Ázerbájdžán',
    dial_code: '+994',
    planet_part: 'Asie'
  },
  {
    name: 'Bahamy',
    dial_code: '+1242',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Bahrajn',
    dial_code: '+973',
    planet_part: 'Asie'
  },
  {
    name: 'Bangladéš',
    dial_code: '+880',
    planet_part: 'Asie'
  },
  {
    name: 'Barbados',
    dial_code: '+1246',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Belgie',
    dial_code: '+32',
    planet_part: 'Evropa'
  },
  {
    name: 'Belize',
    dial_code: '+501',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Bělorusko',
    dial_code: '+375',
    planet_part: 'Evropa'
  },
  {
    name: 'Benin',
    dial_code: '+229',
    planet_part: 'Afrika'
  },
  {
    name: 'Bermudy',
    dial_code: '+1441',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Bhútán',
    dial_code: '+975',
    planet_part: 'Asie'
  },
  {
    name: 'Bolívie',
    dial_code: '+591',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Bosna a Hercegovina',
    dial_code: '+387',
    planet_part: 'Evropa'
  },
  {
    name: 'Botswana',
    dial_code: '+267',
    planet_part: 'Afrika'
  },
  {
    name: 'Brazílie',
    dial_code: '+55',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Britské Panenské ostrovy',
    dial_code: '+1284',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Brunej',
    dial_code: '+673',
    planet_part: 'Asie'
  },
  {
    name: 'Bulharsko',
    dial_code: '+359',
    planet_part: 'Evropa'
  },
  {
    name: 'Burkina Faso',
    dial_code: '+226',
    planet_part: 'Afrika'
  },
  {
    name: 'Burundi',
    dial_code: '+257',
    planet_part: 'Afrika'
  },
  {
    name: 'Cookovy ostrovy',
    dial_code: '+682',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Čad',
    dial_code: '+235',
    planet_part: 'Afrika'
  },
  {
    name: 'Černá Hora',
    dial_code: '+382',
    planet_part: 'Evropa'
  },
  {
    name: 'Čína',
    dial_code: '+86',
    planet_part: 'Asie'
  },
  {
    name: 'Dánsko',
    dial_code: '+45',
    planet_part: 'Evropa'
  },
  {
    name: 'Demokratická republika Kongo',
    dial_code: '+243',
    planet_part: 'Afrika'
  },
  {
    name: 'Diego García',
    dial_code: '+246',
    planet_part: 'Afrika'
  },
  {
    name: 'Dominika',
    dial_code: '+1767',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Dominikánská republika',
    dial_code: '+1809',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Džibutsko',
    dial_code: '+253',
    planet_part: 'Afrika'
  },
  {
    name: 'Egypt',
    dial_code: '+20',
    planet_part: 'Afrika'
  },
  {
    name: 'Ekvádor',
    dial_code: '+593',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Eritrea',
    dial_code: '+291',
    planet_part: 'Afrika'
  },
  {
    name: 'Estonsko',
    dial_code: '+372',
    planet_part: 'Evropa'
  },
  {
    name: 'Etiopie',
    dial_code: '+251',
    planet_part: 'Afrika'
  },
  {
    name: 'Evropský telefonní číslovací prostor (celo-evropské služby)',
    dial_code: '+388',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Faerské ostrovy',
    dial_code: '+298',
    planet_part: 'Evropa'
  },
  {
    name: 'Falklandy',
    dial_code: '+500',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Fidži',
    dial_code: '+679',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Filipíny',
    dial_code: '+63',
    planet_part: 'Asie'
  },
  {
    name: 'Finsko',
    dial_code: '+358',
    planet_part: 'Evropa'
  },
  {
    name: 'Francie',
    dial_code: '+33',
    planet_part: 'Evropa'
  },
  {
    name: 'Francouzská Guyana',
    dial_code: '+594',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Francouzská Polynésie',
    dial_code: '+689',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Gabon',
    dial_code: '+241',
    planet_part: 'Afrika'
  },
  {
    name: 'Gambie',
    dial_code: '+220',
    planet_part: 'Afrika'
  },
  {
    name: 'Ghana',
    dial_code: '+233',
    planet_part: 'Afrika'
  },
  {
    name: 'Gibraltar',
    dial_code: '+350',
    planet_part: 'Evropa'
  },
  {
    name: 'Globální satelitní telefonní systém',
    dial_code: '+881',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Grenada',
    dial_code: '+1473',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Grónsko',
    dial_code: '+299',
    planet_part: 'Evropa'
  },
  {
    name: 'Gruzie',
    dial_code: '+995',
    planet_part: 'Asie'
  },
  {
    name: 'Guadeloupe',
    dial_code: '+590',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Guam',
    dial_code: '+1671',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Guatemala',
    dial_code: '+502',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Guinea',
    dial_code: '+224',
    planet_part: 'Afrika'
  },
  {
    name: 'Guinea-Bissau',
    dial_code: '+245',
    planet_part: 'Afrika'
  },
  {
    name: 'Guyana',
    dial_code: '+592',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Haiti',
    dial_code: '+509',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Honduras',
    dial_code: '+504',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Hongkong',
    dial_code: '+852',
    planet_part: 'Asie'
  },
  {
    name: 'Chile',
    dial_code: '+56',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Chorvatsko',
    dial_code: '+385',
    planet_part: 'Evropa'
  },
  {
    name: 'Indie',
    dial_code: '+91',
    planet_part: 'Asie'
  },
  {
    name: 'Indonésie',
    dial_code: '+62',
    planet_part: 'Asie'
  },
  {
    name: 'Inmarsat – Indický oceán (satelitní síť)',
    dial_code: '+873',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Inmarsat – služba „SNAC“ (satelitní síť)',
    dial_code: '+870',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Inmarsat – Tichý oceán (satelitní síť)',
    dial_code: '+872',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Inmarsat – východní Atlantik (satelitní síť)',
    dial_code: '+871',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Inmarsat – západní Atlantik (satelitní síť)',
    dial_code: '+874',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Irák',
    dial_code: '+964',
    planet_part: 'Asie'
  },
  {
    name: 'Írán',
    dial_code: '+98',
    planet_part: 'Asie'
  },
  {
    name: 'Irsko',
    dial_code: '+353',
    planet_part: 'Evropa'
  },
  {
    name: 'Island',
    dial_code: '+354',
    planet_part: 'Evropa'
  },
  {
    name: 'Itálie (stejná dial_code jako Vatikán)',
    dial_code: '+39',
    planet_part: 'Evropa'
  },
  {
    name: 'Izrael',
    dial_code: '+972',
    planet_part: 'Asie'
  },
  {
    name: 'Jamajka',
    dial_code: '+1876',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Japonsko',
    dial_code: '+81',
    planet_part: 'Asie'
  },
  {
    name: 'Jemen',
    dial_code: '+967',
    planet_part: 'Asie'
  },
  {
    name: 'Jihoafrická republika',
    dial_code: '+27',
    planet_part: 'Afrika'
  },
  {
    name: 'Jižní Korea',
    dial_code: '+82',
    planet_part: 'Asie'
  },
  {
    name: 'Jordánsko',
    dial_code: '+962',
    planet_part: 'Asie'
  },
  {
    name: 'Kajmanské ostrovy',
    dial_code: '+1345',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Kambodža',
    dial_code: '+855',
    planet_part: 'Asie'
  },
  {
    name: 'Kamerun',
    dial_code: '+237',
    planet_part: 'Afrika'
  },
  {
    name: 'Kanada (stejná dial_code jako USA)',
    dial_code: '+1',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Kapverdy',
    dial_code: '+238',
    planet_part: 'Afrika'
  },
  {
    name: 'Katar',
    dial_code: '+974',
    planet_part: 'Asie'
  },
  {
    name: 'Kazachstán (stejná dial_code jako Rusko)',
    dial_code: '+7',
    planet_part: 'Asie'
  },
  {
    name: 'Keňa',
    dial_code: '+254',
    planet_part: 'Afrika'
  },
  {
    name: 'Kiribati',
    dial_code: '+686',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Kolumbie',
    dial_code: '+57',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Komory a Mayotte',
    dial_code: '+269',
    planet_part: 'Afrika'
  },
  {
    name: 'Kongo',
    dial_code: '+242',
    planet_part: 'Afrika'
  },
  {
    name: 'Kostarika',
    dial_code: '+506',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Kuba',
    dial_code: '+53',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Kuvajt',
    dial_code: '+965',
    planet_part: 'Asie'
  },
  {
    name: 'Kypr (Tureckem okupovaná část Kypru má +90)',
    dial_code: '+357',
    planet_part: 'Evropa'
  },
  {
    name: 'Kyrgyzstán',
    dial_code: '+996',
    planet_part: 'Asie'
  },
  {
    name: 'Laos',
    dial_code: '+856',
    planet_part: 'Asie'
  },
  {
    name: 'Lesotho',
    dial_code: '+266',
    planet_part: 'Afrika'
  },
  {
    name: 'Libanon',
    dial_code: '+961',
    planet_part: 'Asie'
  },
  {
    name: 'Libérie',
    dial_code: '+231',
    planet_part: 'Afrika'
  },
  {
    name: 'Libye',
    dial_code: '+218',
    planet_part: 'Afrika'
  },
  {
    name: 'Lichtenštejnsko',
    dial_code: '+423',
    planet_part: 'Evropa'
  },
  {
    name: 'Litva',
    dial_code: '+370',
    planet_part: 'Evropa'
  },
  {
    name: 'Lotyšsko',
    dial_code: '+371',
    planet_part: 'Evropa'
  },
  {
    name: 'Lucembursko',
    dial_code: '+352',
    planet_part: 'Evropa'
  },
  {
    name: 'Macao',
    dial_code: '+853',
    planet_part: 'Asie'
  },
  {
    name: 'Madagaskar',
    dial_code: '+261',
    planet_part: 'Afrika'
  },
  {
    name: 'Maďarsko',
    dial_code: '+36',
    planet_part: 'Evropa'
  },
  {
    name: 'Makedonie',
    dial_code: '+389',
    planet_part: 'Evropa'
  },
  {
    name: 'Malajsie',
    dial_code: '+60',
    planet_part: 'Asie'
  },
  {
    name: 'Malawi',
    dial_code: '+265',
    planet_part: 'Afrika'
  },
  {
    name: 'Maledivy',
    dial_code: '+960',
    planet_part: 'Asie'
  },
  {
    name: 'Mali',
    dial_code: '+223',
    planet_part: 'Afrika'
  },
  {
    name: 'Malta',
    dial_code: '+356',
    planet_part: 'Evropa'
  },
  {
    name: 'Maroko',
    dial_code: '+212',
    planet_part: 'Afrika'
  },
  {
    name: 'Marshallovy ostrovy',
    dial_code: '+692',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Martinik',
    dial_code: '+596',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Mauricius',
    dial_code: '+230',
    planet_part: 'Afrika'
  },
  {
    name: 'Mauritánie',
    dial_code: '+222',
    planet_part: 'Afrika'
  },
  {
    name: 'Mexiko',
    dial_code: '+52',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Mezinárodní osobní telekomunikace',
    dial_code: '+878',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Mezinárodní placené služby',
    dial_code: '+979',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Mezinárodní sítě',
    dial_code: '+882',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Mezinárodní zelená linka (UIFN)',
    dial_code: '+800',
    planet_part: 'nadnárodní'
  },
  {
    name: 'Mikronésie',
    dial_code: '+691',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Moldavsko',
    dial_code: '+373',
    planet_part: 'Evropa'
  },
  {
    name: 'Monako',
    dial_code: '+377',
    planet_part: 'Evropa'
  },
  {
    name: 'Mongolsko',
    dial_code: '+976',
    planet_part: 'Asie'
  },
  {
    name: 'Montserrat',
    dial_code: '+1664',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Mosambik',
    dial_code: '+258',
    planet_part: 'Afrika'
  },
  {
    name: 'Myanmar',
    dial_code: '+95',
    planet_part: 'Asie'
  },
  {
    name: 'Namibie',
    dial_code: '+264',
    planet_part: 'Afrika'
  },
  {
    name: 'Nauru',
    dial_code: '+674',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Německo',
    dial_code: '+49',
    planet_part: 'Evropa'
  },
  {
    name: 'Nepál',
    dial_code: '+977',
    planet_part: 'Asie'
  },
  {
    name: 'Niger',
    dial_code: '+227',
    planet_part: 'Afrika'
  },
  {
    name: 'Nigérie',
    dial_code: '+234',
    planet_part: 'Afrika'
  },
  {
    name: 'Nikaragua',
    dial_code: '+505',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Niue',
    dial_code: '+683',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Nizozemské Antily',
    dial_code: '+599',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Nizozemsko',
    dial_code: '+31',
    planet_part: 'Evropa'
  },
  {
    name: 'Norsko',
    dial_code: '+47',
    planet_part: 'Evropa'
  },
  {
    name: 'Nová Kaledonie',
    dial_code: '+687',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Nový Zéland',
    dial_code: '+64',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Omán',
    dial_code: '+968',
    planet_part: 'Asie'
  },
  {
    name: 'Pákistán',
    dial_code: '+92',
    planet_part: 'Asie'
  },
  {
    name: 'Palau',
    dial_code: '+680',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Palestina',
    dial_code: '+970',
    planet_part: 'Asie'
  },
  {
    name: 'Panama',
    dial_code: '+507',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Papua-Nová Guinea',
    dial_code: '+675',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Paraguay',
    dial_code: '+595',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Peru',
    dial_code: '+51',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Pobřeží slonoviny',
    dial_code: '+225',
    planet_part: 'Afrika'
  },
  {
    name: 'Polsko',
    dial_code: '+48',
    planet_part: 'Evropa'
  },
  {
    name: 'Portoriko (také: +1787)',
    dial_code: '+1939',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Portoriko (také: +1939)',
    dial_code: '+1787',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Portugalsko',
    dial_code: '+351',
    planet_part: 'Evropa'
  },
  {
    name: 'Rakousko',
    dial_code: '+43',
    planet_part: 'Evropa'
  },
  {
    name: 'Réunion',
    dial_code: '+262',
    planet_part: 'Afrika'
  },
  {
    name: 'Rovníková Guinea',
    dial_code: '+240',
    planet_part: 'Afrika'
  },
  {
    name: 'Rumunsko',
    dial_code: '+40',
    planet_part: 'Evropa'
  },
  {
    name: 'Rusko (stejná dial_code jako Kazachstán)',
    dial_code: '+7',
    planet_part: 'Evropa'
  },
  {
    name: 'Rwanda',
    dial_code: '+250',
    planet_part: 'Afrika'
  },
  {
    name: 'Řecko',
    dial_code: '+30',
    planet_part: 'Evropa'
  },
  {
    name: 'Saint-Pierre a Miquelon',
    dial_code: '+508',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Salvador',
    dial_code: '+503',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Samoa',
    dial_code: '+685',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'San Marino',
    dial_code: '+378',
    planet_part: 'Evropa'
  },
  {
    name: 'Saúdská Arábie',
    dial_code: '+966',
    planet_part: 'Asie'
  },
  {
    name: 'Senegal',
    dial_code: '+221',
    planet_part: 'Afrika'
  },
  {
    name: 'Severní Korea',
    dial_code: '+850',
    planet_part: 'Asie'
  },
  {
    name: 'Severní Mariany',
    dial_code: '+167',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Seychely',
    dial_code: '+248',
    planet_part: 'Afrika'
  },
  {
    name: 'Sierra Leone',
    dial_code: '+232',
    planet_part: 'Afrika'
  },
  {
    name: 'Singapur',
    dial_code: '+65',
    planet_part: 'Asie'
  },
  {
    name: 'Slovinsko',
    dial_code: '+386',
    planet_part: 'Evropa'
  },
  {
    name: 'Somálsko',
    dial_code: '+252',
    planet_part: 'Afrika'
  },
  {
    name: 'Spojené arabské emiráty',
    dial_code: '+971',
    planet_part: 'Asie'
  },
  {
    name: 'Spojené království (též Anglie či Velká Británie)',
    dial_code: '+44',
    planet_part: 'Evropa'
  },
  {
    name: 'Spojené namey americké – USA – (stejně Kanada)',
    dial_code: '+1',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Srbsko',
    dial_code: '+381',
    planet_part: 'Evropa'
  },
  {
    name: 'Srí Lanka',
    dial_code: '+94',
    planet_part: 'Asie'
  },
  {
    name: 'Středoafrická republika',
    dial_code: '+236',
    planet_part: 'Afrika'
  },
  {
    name: 'Súdán',
    dial_code: '+249',
    planet_part: 'Afrika'
  },
  {
    name: 'Surinam',
    dial_code: '+597',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Svatá Helena',
    dial_code: '+290',
    planet_part: 'Afrika'
  },
  {
    name: 'Svatá Lucie',
    dial_code: '+1758',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Svatý Kryštof a Nevis',
    dial_code: '+1869',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Svatý Tomáš a Princův ostrov',
    dial_code: '+239',
    planet_part: 'Afrika'
  },
  {
    name: 'Svatý Vincenc a Grenadiny',
    dial_code: '+1784',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Svazijsko',
    dial_code: '+268',
    planet_part: 'Afrika'
  },
  {
    name: 'Sýrie',
    dial_code: '+963',
    planet_part: 'Asie'
  },
  {
    name: 'Šalamounovy ostrovy',
    dial_code: '+677',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Španělsko',
    dial_code: '+34',
    planet_part: 'Evropa'
  },
  {
    name: 'Švédsko',
    dial_code: '+46',
    planet_part: 'Evropa'
  },
  {
    name: 'Švýcarsko',
    dial_code: '+41',
    planet_part: 'Evropa'
  },
  {
    name: 'Tádžikistán',
    dial_code: '+992',
    planet_part: 'Asie'
  },
  {
    name: 'Tanzanie',
    dial_code: '+255',
    planet_part: 'Afrika'
  },
  {
    name: 'Thajsko',
    dial_code: '+66',
    planet_part: 'Asie'
  },
  {
    name: 'Tchaj-wan',
    dial_code: '+886',
    planet_part: 'Asie'
  },
  {
    name: 'Togo',
    dial_code: '+228',
    planet_part: 'Afrika'
  },
  {
    name: 'Tokelau',
    dial_code: '+690',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Tonga',
    dial_code: '+676',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Trinidad a Tobago',
    dial_code: '+1868',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Tunisko',
    dial_code: '+216',
    planet_part: 'Afrika'
  },
  {
    name: 'Turecko',
    dial_code: '+90',
    planet_part: 'Evropa'
  },
  {
    name: 'Turkmenistán',
    dial_code: '+993',
    planet_part: 'Asie'
  },
  {
    name: 'Turks a Caicos',
    dial_code: '+1649',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Tuvalu',
    dial_code: '+688',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Uganda',
    dial_code: '+256',
    planet_part: 'Afrika'
  },
  {
    name: 'Ukrajina',
    dial_code: '+380',
    planet_part: 'Evropa'
  },
  {
    name: 'Uruguay',
    dial_code: '+598',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'USA – Spojené namey americké (stejně Kanada)',
    dial_code: '+1',
    planet_part: 'Severní Amerika'
  },
  {
    name: 'Uzbekistán',
    dial_code: '+998',
    planet_part: 'Asie'
  },
  {
    name: 'Vanuatu',
    dial_code: '+678',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Vatikán (stejná dial_code jako Itálie)',
    dial_code: '+39',
    planet_part: 'Evropa'
  },
  {
    name: 'Venezuela',
    dial_code: '+58',
    planet_part: 'Jižní Amerika'
  },
  {
    name: 'Vietnam',
    dial_code: '+84',
    planet_part: 'Asie'
  },
  {
    name: 'Východní Timor',
    dial_code: '+670',
    planet_part: 'Asie'
  },
  {
    name: 'Wallis a Futuna',
    dial_code: '+681',
    planet_part: 'Austrálie a Oceánie'
  },
  {
    name: 'Zambie',
    dial_code: '+260',
    planet_part: 'Afrika'
  },
  {
    name: 'Zimbabwe',
    dial_code: '+263',
    planet_part: 'Afrika'
  }
];

export default phoneDials;
